
import Vue from 'vue'
export default Vue.extend({
  name: 'HintTooltip',
  props: {
    copy: {
      type: String,
      default: '',
    },
    title: {
      type: String,
      default: '',
    },
    timeout: {
      type: Number,
      default: 5000,
    },
    position: {
      type: String,
      default: 'left',
      validator: (value: string) => ['left', 'right', 'top', 'bottom'].includes(value)
    },
    arrowPosition: {
      type: String,
      default: 'rt',
      validator: (value: string) => ['tl', 'tr', 'tc', 'bl', 'br', 'bc', 'lt', 'lb', 'lc', 'rt', 'rb', 'rc'].includes(value)
    },
  },
  data() {
    return {
      isHintTooltipActive: false,
      hintTooltipTimeout: this.timeout,
      hintTooltipTimeoutID: -1 as any,
    }
  },
  methods: {
    showHintTooltip() {
      this.isHintTooltipActive = true

      this.hintTooltipTimeoutID = setTimeout(() => {
        this.hideHintTooltip()
      }, this.hintTooltipTimeout)
    },
    hideHintTooltip() {
      this.isHintTooltipActive = false
      clearTimeout(this.hintTooltipTimeoutID)
    },
    toggleHintTooltip() {
      if (this.isHintTooltipActive) {
        this.hideHintTooltip()
      } else {
        this.showHintTooltip()
      }
    }
  },
})
